import { Component, Input } from "@angular/core"
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap"

@Component({
    selector: "app-auth-modal",
    templateUrl: "./auth-modal.component.html",
    styleUrls: ["./auth-modal.component.less"],
})
export class AuthModalComponent {
    @Input() public nextURL: string = null
    @Input() public description: string = ""
    @Input() public overrideStudentNext: boolean = false

    constructor(public activeModal: NgbActiveModal) {}
}
